var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('span',[_vm._v(_vm._s((_vm.status || '').toString().replace(/-/g, ' ')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }